var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ketchConsentAdapter } from './ketch.js';
import { onetrustConsentAdapter } from './onetrust.js';
import { shopifyConsentAdapter } from './shopify.js';
export const addCdpConsent = (options) => {
    let adapter = null;
    const POLLING_INTERVAL_MS = 50;
    const TIMEOUT_MS = 60000;
    /**
     * Returns the adapter for the specified consent management platform.
     */
    const getAdapter = () => {
        var _a;
        switch ((_a = options.consent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) {
            case 'ketch':
                return ketchConsentAdapter();
            case 'onetrust':
                return onetrustConsentAdapter();
            case 'shopify':
                return shopifyConsentAdapter();
            default:
                return null;
        }
    };
    /**
     * Polls if user can be tracked based on consent
     * @returns Promise that resolves to true if condition is met within timeout, false otherwise
     */
    const checkUserCanBeTracked = () => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve) => {
            // Checking immediately first
            if (adapter === null || adapter === void 0 ? void 0 : adapter.userCanBeTracked()) {
                resolve(true);
                return;
            }
            const interval = setInterval(() => {
                if (adapter === null || adapter === void 0 ? void 0 : adapter.userCanBeTracked()) {
                    clearInterval(interval);
                    resolve(true);
                }
            }, POLLING_INTERVAL_MS);
            setTimeout(() => {
                clearInterval(interval);
                resolve(false);
            }, TIMEOUT_MS);
        });
    });
    /**
     * Updates consent for all future events.
     */
    const updateCdpConsent = (updatedConsent) => {
        const cdp = window[`_${options.namespace}`];
        if (cdp && typeof cdp.configure === 'function') {
            cdp.configure({ privacy: updatedConsent });
        }
        else {
            // CDP has not yet loaded via the snippet.
            window.jitsuConfig = { privacy: updatedConsent };
        }
    };
    /**
     * Sets up consent management by initializing the adapter and handling consent updates.
     */
    const setupConsentManagement = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!adapter)
            return;
        const isReady = yield checkUserCanBeTracked();
        if (!isReady)
            return;
        const initialConsent = adapter.getCurrentConsent();
        updateCdpConsent(initialConsent);
        adapter.handleConsentUpdates((updatedConsent) => {
            updateCdpConsent(updatedConsent);
        });
    });
    /**
     * Initializes consent management.
     * Returns a promise that resolves to true if CDP should be loaded, false otherwise.
     */
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        adapter = getAdapter();
        if (adapter === null) {
            console.error(`Consent management adapter "${options.consent}" is not supported.`);
            return false;
        }
        if (options.awaitConsent) {
            const canBeTracked = yield checkUserCanBeTracked();
            if (!canBeTracked)
                return false;
        }
        // Set up consent management in the background
        setupConsentManagement().catch((error) => {
            console.error('Error setting up consent management:', error);
        });
        return true;
    });
    return {
        init,
    };
};
